// GERADO por scripts/gerar_ibge.mjs a partir de dados/ibge/paises.json. Não editar à mão.
// Os 193 países da tabela do IBGE: [sigla ISO alpha-2, nome]. Ver dados/ibge/LEIAME.md.
export const PAISES_IBGE = Object.freeze([
  ["AD", "Andorra"],
  ["AE", "Emirados Árabes Unidos"],
  ["AF", "Afeganistão"],
  ["AG", "Antígua e Barbuda"],
  ["AL", "Albânia"],
  ["AM", "Armênia"],
  ["AO", "Angola"],
  ["AR", "Argentina"],
  ["AT", "Áustria"],
  ["AU", "Austrália"],
  ["AZ", "Azerbaijão"],
  ["BA", "Bósnia e Herzegovina"],
  ["BB", "Barbados"],
  ["BD", "Bangladesh"],
  ["BE", "Bélgica"],
  ["BF", "Burkina Faso"],
  ["BG", "Bulgária"],
  ["BH", "Barein"],
  ["BI", "Burundi"],
  ["BJ", "Benin"],
  ["BN", "Brunei"],
  ["BO", "Bolívia"],
  ["BR", "Brasil"],
  ["BS", "Bahamas"],
  ["BT", "Butão"],
  ["BW", "Botsuana"],
  ["BY", "Belarus"],
  ["BZ", "Belize"],
  ["CA", "Canadá"],
  ["CD", "República Democrática do Congo"],
  ["CF", "República Centro-Africana"],
  ["CG", "República do Congo"],
  ["CH", "Suíça"],
  ["CI", "Costa do Marfim"],
  ["CL", "Chile"],
  ["CM", "Camarões"],
  ["CN", "China"],
  ["CO", "Colômbia"],
  ["CR", "Costa Rica"],
  ["CU", "Cuba"],
  ["CV", "Cabo Verde"],
  ["CY", "Chipre"],
  ["CZ", "República Tcheca"],
  ["DE", "Alemanha"],
  ["DJ", "Djibouti"],
  ["DK", "Dinamarca"],
  ["DM", "Dominica"],
  ["DO", "República Dominicana"],
  ["DZ", "Argélia"],
  ["EC", "Equador"],
  ["EE", "Estônia"],
  ["EG", "Egito"],
  ["ER", "Eritreia"],
  ["ES", "Espanha"],
  ["ET", "Etiópia"],
  ["FI", "Finlândia"],
  ["FJ", "Fiji"],
  ["FM", "Micronésia"],
  ["FR", "França"],
  ["GA", "Gabão"],
  ["GB", "Reino Unido"],
  ["GD", "Granada"],
  ["GE", "Geórgia"],
  ["GH", "Gana"],
  ["GM", "Gâmbia"],
  ["GN", "Guiné"],
  ["GQ", "Guiné Equatorial"],
  ["GR", "Grécia"],
  ["GT", "Guatemala"],
  ["GW", "Guiné-Bissau"],
  ["GY", "Guiana"],
  ["HN", "Honduras"],
  ["HR", "Croácia"],
  ["HT", "Haiti"],
  ["HU", "Hungria"],
  ["ID", "Indonésia"],
  ["IE", "Irlanda"],
  ["IL", "Israel"],
  ["IN", "Índia"],
  ["IQ", "Iraque"],
  ["IR", "Irã"],
  ["IS", "Islândia"],
  ["IT", "Itália"],
  ["JM", "Jamaica"],
  ["JO", "Jordânia"],
  ["JP", "Japão"],
  ["KE", "Quênia"],
  ["KG", "Quirguistão"],
  ["KH", "Camboja"],
  ["KI", "Kiribati"],
  ["KM", "Comores"],
  ["KN", "São Cristóvão e Nevis"],
  ["KP", "República Popular Democrática da Coreia"],
  ["KR", "República da Coreia"],
  ["KW", "Kuwait"],
  ["KZ", "Cazaquistão"],
  ["LA", "Laos"],
  ["LB", "Líbano"],
  ["LC", "Santa Lúcia"],
  ["LI", "Liechtenstein"],
  ["LK", "Sri Lanka"],
  ["LR", "Libéria"],
  ["LS", "Lesoto"],
  ["LT", "Lituânia"],
  ["LU", "Luxemburgo"],
  ["LV", "Letônia"],
  ["LY", "Líbia"],
  ["MA", "Marrocos"],
  ["MC", "Mônaco"],
  ["MD", "Moldávia"],
  ["ME", "Montenegro"],
  ["MG", "Madagascar"],
  ["MH", "Ilhas Marshall"],
  ["MK", "Macedônia do Norte"],
  ["ML", "Mali"],
  ["MM", "Mianmar"],
  ["MN", "Mongólia"],
  ["MR", "Mauritânia"],
  ["MT", "Malta"],
  ["MU", "Maurício"],
  ["MV", "Maldivas"],
  ["MW", "Malauí"],
  ["MX", "México"],
  ["MY", "Malásia"],
  ["MZ", "Moçambique"],
  ["NA", "Namíbia"],
  ["NE", "Niger"],
  ["NG", "Nigéria"],
  ["NI", "Nicarágua"],
  ["NL", "Países Baixos"],
  ["NO", "Noruega"],
  ["NP", "Nepal"],
  ["NR", "Nauru"],
  ["NZ", "Nova Zelândia"],
  ["OM", "Omã"],
  ["PA", "Panamá"],
  ["PE", "Peru"],
  ["PG", "Papua Nova Guiné"],
  ["PH", "Filipinas"],
  ["PK", "Paquistão"],
  ["PL", "Polônia"],
  ["PT", "Portugal"],
  ["PW", "Palau"],
  ["PY", "Paraguai"],
  ["QA", "Catar"],
  ["RO", "Romênia"],
  ["RS", "Sérvia"],
  ["RU", "Rússia (Federação Russa)"],
  ["RW", "Ruanda"],
  ["SA", "Arábia Saudita"],
  ["SB", "Ilhas Salomão"],
  ["SC", "Seichelles"],
  ["SD", "Sudão"],
  ["SE", "Suécia"],
  ["SG", "Singapura"],
  ["SI", "Eslovênia"],
  ["SK", "Eslováquia"],
  ["SL", "Serra Leoa"],
  ["SM", "San Marino"],
  ["SN", "Senegal"],
  ["SO", "Somália"],
  ["SR", "Suriname"],
  ["SS", "Sudão do Sul"],
  ["ST", "São Tomé e Príncipe"],
  ["SV", "El Salvador"],
  ["SY", "Síria"],
  ["SZ", "Eswatini"],
  ["TD", "Chade"],
  ["TG", "Togo"],
  ["TH", "Tailândia"],
  ["TJ", "Tadjiquistão"],
  ["TL", "Timor-Leste"],
  ["TM", "Turcomenistão"],
  ["TN", "Tunísia"],
  ["TO", "Tonga"],
  ["TR", "Turquia"],
  ["TT", "Trinidad e Tobago"],
  ["TV", "Tuvalu"],
  ["TZ", "Tanzânia"],
  ["UA", "Ucrânia"],
  ["UG", "Uganda"],
  ["US", "Estados Unidos da América"],
  ["UY", "Uruguai"],
  ["UZ", "Uzbequistão"],
  ["VC", "São Vicente e Granadinas"],
  ["VE", "Venezuela"],
  ["VN", "Vietnã"],
  ["VU", "Vanuatu"],
  ["WS", "Samoa"],
  ["YE", "Iêmen"],
  ["ZA", "África do Sul"],
  ["ZM", "Zâmbia"],
  ["ZW", "Zimbábue"],
]);
